import React from "react";

const PATHS = {
  logo: "M6.5 9h11M12 4v16M8 20h8M8.5 9 5 15h7L8.5 9Zm7 0L12 15h7l-3.5-6Z",
  law: "M6.5 9h11M12 4v16M8 20h8M8.5 9 5 15h7L8.5 9Zm7 0L12 15h7l-3.5-6Z",
  tax: "M4 7h16M6 7V5h12v2M7 7v12h10V7M9 11h6M9 15h6",
  document: "M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Zm0 0v5h5M8 13h8M8 17h6",
  prediction: "M12 3a9 9 0 1 0 9 9M12 7v5l3 2M17 3h4v4M21 3l-6 6",
  draft: "M4 20h16M6 16l9.5-9.5 2 2L8 18H6v-2ZM14 6l2-2 2 2-2 2",
  tools: "M14.7 6.3a4 4 0 0 0-5 5L4 17v3h3l5.7-5.7a4 4 0 0 0 5-5l-2.4 2.4-2-2 2.4-2.4Z",
  map: "M9 18 3 21V6l6-3 6 3 6-3v15l-6 3-6-3ZM9 3v15M15 6v15",
  user: "M20 21a8 8 0 0 0-16 0M12 13a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
  history: "M3 12a9 9 0 1 0 3-6.7M3 4v5h5M12 7v5l3 2",
  admin: "M4 21V8l8-5 8 5v13M9 21v-7h6v7M8 10h.01M12 10h.01M16 10h.01",
  chevron: "M6 9l6 6 6-6",
  send: "M4 12h15M13 6l6 6-6 6",
  check: "M20 6 9 17l-5-5",
  alert: "M12 9v4M12 17h.01M10.3 4.3 2.6 18a2 2 0 0 0 1.7 3h15.4a2 2 0 0 0 1.7-3L13.7 4.3a2 2 0 0 0-3.4 0Z",
  mail: "M4 5h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Zm18 3-10 6L2 8",
  lock: "M7 11V8a5 5 0 0 1 10 0v3M6 11h12v10H6V11Zm6 4v2",
  chart: "M4 19V5M4 19h16M8 16v-5M12 16V8M16 16v-8",
  users: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75",
  message: "M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v8Z",
  database: "M4 6c0-2 4-3 8-3s8 1 8 3-4 3-8 3-8-1-8-3Zm0 0v6c0 2 4 3 8 3s8-1 8-3V6M4 12v6c0 2 4 3 8 3s8-1 8-3v-6",
  bot: "M12 8V4M8 4h8M6 10h12a2 2 0 0 1 2 2v6a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-6a2 2 0 0 1 2-2Zm3 5h.01M15 15h.01",
  close: "M6 6l12 12M18 6 6 18",
};

export default function BrandIcon({ name = "logo", size = 20, className = "", strokeWidth = 1.8, title }) {
  const path = PATHS[name] || PATHS.logo;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden={title ? undefined : true}
      role={title ? "img" : undefined}
    >
      {title && <title>{title}</title>}
      <path d={path} />
    </svg>
  );
}